module.exports = __webpack_public_path__ + "media/images/icons/filled/experiment-7c038389b7aed2ca554b05b4fa7ce7f1.svg";